import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { Tab, TabList } from 'components/atoms/tabs';
import FormViewGrid from 'components/atoms/form/FormViewGrid';
import FormHeading from 'components/atoms/form/FormHeading';
import ActiveStatusLabel from 'components/atoms/labels/ActiveStatusLabel';

const UserTabView = (props) => {
    const userId = get(props, 'user.id', null);
    const firstName = get(props, 'user.firstName', null);
    const lastName = get(props, 'user.lastName', null);
    const isActive = get(props, 'user.isActive', true);
    const userFullname = `${firstName} ${lastName}`;
    const editUserLink = (
        <Link to={`/admin/users/${userId}/edit`} title="Edit User">
            <span className="icon-edit" />
        </Link>
    );
    /*
    Saving this tab for when we introduce subscriptions
    {props.currentUser ?
        (props.currentUser.scope.includes('G90-QA-View')
        && <Tab
            selected={props.selected === 'subscriptions'}
            onClick={() => props.push(`/admin/users/${userId}/subscriptions`)}>
                Subscriptions
        </Tab>)
        : null}
    */
    return (
        <FormViewGrid fluid>
            <FormHeading>
                {userFullname}
                {userId && editUserLink}
            </FormHeading>
            <ActiveStatusLabel isActive={isActive} />
            <TabList>
                <Tab selected={props.selected === 'info'} onClick={() => props.push(`/admin/users/${userId}`)}>Info</Tab>
            </TabList>
            {props.children}
        </FormViewGrid>
    );
};

UserTabView.propTypes = {
    selected: PropTypes.string,
    currentUser: PropTypes.object,
    user: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
    }),
    push: PropTypes.func
};

export default UserTabView;



// WEBPACK FOOTER //
// ./src/components/organisms/user/UserTabView.js